import { Component, Input, OnInit, QueryList, ViewChildren } from '@angular/core';
import { ETipoPreferencia } from 'src/app/models/enums.enum';
import { GrupoPreferenciaComponent } from '../../../form-componentes/grupo-preferencia/grupo-preferencia.component';
import { IFichaCliente, IPreferenciaCliente } from 'src/app/models/interfaces-apis/ficha_cliente';
import { IPreferencia } from 'src/app/models/interfaces-apis/diccionarios';
import { preferencias } from 'src/app/models/General/preferencias';

@Component({
  selector: 'app-usuario-perfil',
  templateUrl: './usuario-perfil.component.html',
  styleUrls: ['./usuario-perfil.component.scss']
})
export class UsuarioPerfilComponent extends preferencias implements OnInit {

  @ViewChildren('Grupo_Preferencia') grupos!: QueryList<GrupoPreferenciaComponent>;

  @Input() preferencias: IPreferencia[];

  @Input() listaOtros: string[];

  @Input() clienteFicha: IFichaCliente;

  TipoPreferencia = ETipoPreferencia;

  constructor() {
    super();
  }

  ngOnInit(): void {

  }


  //Obtener la lista de las preferencias guardadas
  obtenerPreferenciasGuardadas(): [IPreferenciaCliente[]] {

    let ListaPreferencias: IPreferenciaCliente[] = [];

    this.grupos.forEach((grupo) => {
      let resultado = grupo.obtenerPreferencias();
      let opcionesPreferencias: IPreferenciaCliente = {
        Tipo: grupo.Id,
        Preferencias: resultado[0],
        InfoEspecifica: resultado[1]
      };
      ListaPreferencias.push(opcionesPreferencias);
    });
    return [ListaPreferencias];
    
  }

  //Actualizar las preferencias del Perfil
  actualizar() {
    let preferencias = this.clienteFicha.Preferencias;
    
    let preferenciasTipo0 = this.preferencias.filter(o => o.TipoProducto === 0);
    let idsPreferencias = preferenciasTipo0.map(o => o.Id);
    
    let resultado = preferencias.filter(o => idsPreferencias.includes(o.Tipo));

    this.grupos.forEach((grupo) => {
      const preferencia = resultado.find(p => p.Tipo === grupo.Id);
      if (preferencia) {
        grupo.actualizar(preferencia.Preferencias, preferencia.InfoEspecifica);
      }
    });
      
  }

  //Validar las preferencias del Perfil
  validarPreferencias() {
    let validacionPerfil = this.grupos.toArray().every(grupo => grupo.validarPreferencias());
    return validacionPerfil;
  }

}
